export default {
  methods: {
    roundInteger(num) {
      return Math.round(num);
    }
  }
}
